import { render, staticRenderFns } from "./ViewChat.vue?vue&type=template&id=6c4fbc61&scoped=true&"
import script from "./ViewChat.vue?vue&type=script&scoped=true&lang=js&"
export * from "./ViewChat.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./ViewChat.vue?vue&type=style&index=0&id=6c4fbc61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4fbc61",
  null
  
)

export default component.exports